module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc20-2a7058da414d77f3b7f572151d898d84.jpg";